module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "dragBox"
    }
  }, [_c('vue-dropzone', {
    ref: "myVueDropzone",
    attrs: {
      "id": _vm.id,
      "options": _vm.dropzoneOptions,
      "duplicateCheck": true
    },
    on: {
      "vdropzone-file-added": _vm.vfileAdded,
      "vdropzone-success": _vm.vsuccess,
      "vdropzone-error": _vm.verror,
      "vdropzone-removed-file": _vm.vremoved,
      "vdropzone-sending": _vm.vsending,
      "vdropzone-success-multiple": _vm.vsuccessMuliple,
      "vdropzone-sending-multiple": _vm.vsendingMuliple,
      "vdropzone-queue-complete": _vm.vqueueComplete,
      "vdropzone-total-upload-progress": _vm.vprogress,
      "vdropzone-mounted": _vm.vmounted,
      "vdropzone-drop": _vm.vddrop,
      "vdropzone-drag-start": _vm.vdstart,
      "vdropzone-drag-end": _vm.vdend,
      "vdropzone-drag-enter": _vm.vdenter,
      "vdropzone-drag-over": _vm.vdover,
      "vdropzone-drag-leave": _vm.vdleave,
      "vdropzone-duplicate-file": _vm.vdduplicate
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d29cf87"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Menu/Temp/ImgUpdateDropTemp.vue
// module id = 2443
// module chunks = 1